export const zahtjev_HZMO = {
    templateId: 52.1,
    category: 6,
    templateTitle: "Zahtjev za podatke o osiguraniku - HZMO",
    templateDescription: `<p>Vjerovnik ima pravo prije, tijekom ili nakon postupka ovrhe (ovrhe na računima fizičke osobe ili bilo kojeg drugog ovršnog postupka prema fizičkoj osobi), od HZMO zatražiti podatak o tome gdje je dužnik (fizička osoba) osiguran i po kojoj osnovi - plaća, mirovina i sl., radi eventualnog pokretanja ovrhe na plaći.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Kako bi naplatio svoju tražbinu, vjerovnik (ovrhovoditelj) ima pravo zatražiti od HZMO podatak o tome je li dužnik (fizička osoba) osiguranik u Hrvatskom zavodu za mirovinsko osiguranje, po kojoj osnovi (radni odnos, samostalna profesionalna djelatnost, obrt ili samostalna djelatnost poljoprivrede) i kod koga, odnosno prima li mirovinu, naknadu zbog tjelesnog oštećenja ili koju drugu stalnu naknadu o kojoj vodi evidenciju.</p>
    <p>Na temelju dobivenog podatka i dokaza o nemogućnosti ovrhe na računima ovršenika uz dokaz FINA-e o nemogućnosti naplate, vjerovnik može pokrenuti ovrhu na stalnom novčanom primanju odnosno zatražiti provedbu ovrhe na drugom predmetu ili drugim sredstvom (nastavna ovrha).</p>
    <p>HZMO nije dužan postupiti po zahtjevu osobe koja traži podatke o dužniku ako prethodno nisu podmireni troškovi za poduzimanje radnji u iznosu od 20,00 kn, stoga je podnositelj obvezan uz pojedinačni zahtjev za izdavanje potvrde za svakog dužnika, pored prilaganja isprava na kojima se temelji tražbina (služe kao dokaz o postojanju pravnog interesa), priložiti i dokaz o podmirenju naknade u iznosu od 20,00 kn.</p>
    <p>Naknadu ovih troškova podnositelj zahtjeva plaća u korist računa državnog proračuna RH, IBAN HR 1210010051863000160 model HR26 i poziv na broj odobrenja 5908-9563-OIB uplatitelja.</p>
    <p>Kao dokaz o izvršenom plaćanju prilaže se separat izvatka po računu (pravna osoba i fizička osoba koja obavlja gospodarsku djelatnost) odnosno primjerak naloga za plaćanje (obrazac HUB3) s vidljivom ovjerom izvršenja, a u slučaju elektroničkog plaćanja potvrda o provedenom nalogu za plaćanje s ovjerom banke (transakcijski kod).</p>
    <br>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [
          {
        type: "input",
        required: true,
        placeholder: "Upisati HZMO i podr. službu",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
 
   
   title: 'Zahtjev za dostavom podataka o osiguraniku',
   noArticleNumbers: true,
   noArticleTitle: true,

   articles: [

    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                     { type: "text", content: "Poštovani,\r\n\r\n"},
                    { type: "text", newline:"true", content: "na temelju članka 18. st. 1. Ovršnog zakona zahtijevamo da nam dostavite podatak o tome da li je" },
            { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
            { type: "text", content: "," },
            { type: 'text', content: 'iz',},
            { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
            { type: 'text', content: ',' },
            { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { help: "Ovdje upisujete podatke osobe protiv koje namjeravate pokrenuti ovršni postupak."},
            { type: "text", content: "osiguranik u Hrvatskom zavodu za mirovinsko osiguranje, po kojoj osnovi (radni odnos, samostalna profesionalna djelatnost, obrt ili samostalna djelatnost poljoprivrede) i kod koga, odnosno prima li mirovinu, naknadu zbog tjelesnog oštećenja ili koju drugu stalnu naknadu o kojoj se u Zavodu vodi evidencija." }, 
          ],
        }
      ]
    },
              {
                title: '',
                mandatory: true,
                dummy: true,
                statements: [
                    {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Ovim putem vas pozivamo da nam tražene podatke dostavite u zakonskom roku od 8 dana te vas u tom smislu upozoravamo na odredbu čl. 18. st. 7. Ovršnog zakona.',
                        value: '',
                    }],
            },
            {
                title: '',
                mandatory: true,
                dummy: true,
                statements: [
                    {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Naime, protiv navedene osobe namjeravamo pokrenuti ovršni postupak, a dokaz o postojanju pravno interesa prilažemo uz ovaj Zahtjev.',
                        value: '',
                        help: 'Tijela od kojih se traže podaci, zahtijevaju postojanje pravnog interesa za traženje takvih podataka, stoga je potrebno poslati podatke na temelju kojima se može dokazati pravni interes - Izvod otvorenih stavaka, račun i sl..',
                    }],
            },
            {
                title: '',
                mandatory: true,
                dummy: true,
                statements: [
                    {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Molimo za hitnost u postupanju.',
                        value: '',
                    }],
            },
            {
                title: "",
                mandatory: false,
                dummy: true,
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      { type: "text", content: "Kontakt telefon:" },
                      { type: 'input', value: '', required: true, },
                      { help: "Ovdje upisujete Vaše kontakt podatke što može biti korisno u slučaju potrebe razjašnjenja ili pitanja tijela koje zaprima zahtjev."},
                    ],
                  }
                ]
              },
              {
                mandatory: true,
                static: true,
                type: 2, // date and place
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      {
                        type: "text",
                        content: "U"
                      },
                      {
                        type: "input",
                        value: "",
                        placeholder: "Upišite mjesto.",
                        required: true,
                      },
                      {
                        type: "text",
                        content: ", dana"
                      },
                      {
                        type: "date",
                        value: new Date(),
                        required: true
                      },
                      {
                        type: "text",
                        content: "godine."
                      }
                    ]
                  },
                ]
              },
               {
                   mandatory: true,
                   static: true,
                   type: 3,  // signatures
                   statements: [],
               },
               {
                   static: true,
                   mandatory: false,
                   type: 4, 
                   statements: [
                     {
                       type: 'text',
                       mandatory: true,
                       editable: true,
                       content: 'Prilog: \r\n1) Dokaz o postajanju pravnog interesa \r\n2) Dokaz o izvršenom plaćanju (20,00 kn)',
                       help: 'Nužno je priložiti dokaz o postojanju pravnog interesa - to mogu biti računi, izvodi iz poslovnih knjiga (izvodi otvorenih stavaka), presude, ugovori i sl..'
                    }
                   ]
                 },
                 {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Primatelju zahtjeva \r\n2) Arhiva',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
           ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/52.1_zahtjev_HZMO.ts